import { useState, Fragment, useEffect } from 'react'
import { useHistory } from 'react-router-dom';
import { Collapse, Drawer, IconButton, List, ListItemButton, ListItemIcon, ListItemText, useTheme } from '@mui/material';
import { ExpandLess, ExpandMore, Close, Settings, SportsEsports, ShoppingCartRounded, SearchRounded, SupervisorAccountRounded, Home, BugReport } from '@mui/icons-material';
import { Box } from '@mui/system';

import { IUserRoles, useUserState } from 'contexts/user';
import Clock from './clock'
import { config } from 'config';

const menus = [
  {
    title: 'HOME',
    path: `/home`,
    icon: <Home />
  },
  {
    title: 'GAME SETTING',
    children: [
      {
        title: 'Meta', children: [
          { title: 'Ads', path: '/gamesetting/meta/ads' },
          { title: 'Cash Exchange Steps', path: '/gamesetting/meta/cashexchangesteps' },
          { title: 'Withdrawal Steps', path: '/gamesetting/meta/withdrawalsteps' },
          { title: 'Time Gift', path: '/gamesetting/meta/timegift' },
          { title: 'Levels', path: '/gamesetting/meta/levels' },
          { title: 'Vip', path: '/gamesetting/meta/vip' },
          { title: 'Random Box', path: '/gamesetting/meta/randombox' },
          { title: 'Items', path: '/gamesetting/meta/items' }
        ]
      },
      { title: 'Web Links', path: '/gamesetting/weblinks' },
      { title: 'MCODE', path: '/gamesetting/mcode' },
      { title: 'Cash Bounce Back', path: '/gamesetting/cbb' },
      { title: 'AdValue', path: '/gamesetting/advalue' },
      { title: 'ELO', path: '/gamesetting/elo' },
      { title: 'ETC', path: '/gamesetting/etc' },
      { title: 'Max. Reward Values', path: '/gamesetting/maxrewards' },
      { title: 'Game Version', path: '/gamesetting/gameversion' },
    ],
    icon: <Settings />
  },
  {
    title: 'GAME MANAGEMENT',
    children: [
      { title: 'Contents On/Off', path: '/gamemanagement/contents' },
      {
        title: 'Maintenance', children: [
          { title: 'Schedule', path: '/gamemanagement/maintenance/schedule' },
          { title: 'Expire Leagues', path: '/gamemanagement/maintenance/leagueexpired' }
        ]
      },
      {
        title: 'Message', children: [
          { title: 'System Notice', path: '/gamemanagement/message/systemnotice' },
          { title: 'Message Notice', path: '/gamemanagement/message/notice' },
          { title: 'TOU / PP', path: '/gamemanagement/message/toupp' },
          { title: 'Operator Payment', path: '/gamemanagement/message/operatorpayment' }
        ]
      },
      {
        title: 'Gateway', children: [
          { title: 'Gateway v1', path: '/gamemanagement/gateway/gateway_v1' },
          { title: 'Gateways v2', path: '/gamemanagement/gateway/gateways' },
          { title: 'Staging', path: '/gamemanagement/gateway/staging' },
          { title: 'Whitelist', path: '/gamemanagement/gateway/whitelist' },
          { title: 'Blacklist', path: '/gamemanagement/gateway/blacklist' }
        ]
      },
      {
        title: 'League', children: [
          { title: 'League Config', path: '/gamemanagement/league/config' },
          { title: 'League Data', path: '/gamemanagement/league/data' },
          { title: 'League Schedule', path: '/gamemanagement/league/schedule' }
        ]
      },
      {
        title: 'Attendance', children: [
          { title: 'Reward Config', path: '/gamemanagement/attendance/config' },
          { title: 'Control', path: '/gamemanagement/attendance/control' }
        ]
      },
      {
        title: 'Promo Code', children: [
          { title: 'Promo Coupon', path: '/gamemanagement/promocode/promocoupon' },
          { title: 'Invite Control', path: '/gamemanagement/promocode/invitecontrol' },
          { title: 'Invite Quest', path: '/gamemanagement/promocode/invitequest' }
        ]
      },
      {
        title: 'Bingo Ball', children: [
          { title: 'Rewards', path: '/gamemanagement/bingoball/rewards' },
          { title: 'Leagues', path: '/gamemanagement/bingoball/leagues' },
          { title: 'Schedule', path: '/gamemanagement/bingoball/schedule' }
        ]
      },
      { title: 'Cash Mine', path: '/gamemanagement/cashmine' },
      { title: 'Event Data', path: '/gamemanagement/event/data' },
      { title: 'Mission', path: '/gamemanagement/mission' },
      { title: 'Mini Game', path: '/gamemanagement/minigame' },
      { title: 'Prize Ranking', path: '/gamemanagement/prizeranking' },
      { title: 'Segment', path: '/gamemanagement/segment' },
      { title: 'OneLink', path: '/gamemanagement/onelink' },
      { title: 'Push', path: '/gamemanagement/pushschedule' },
      { title: 'Moderate Pictures', path: '/gamemanagement/moderatepictures' },
      { title: 'Winners Tip', path: '/gamemanagement/winnerstip' },
    ],
    icon: <SportsEsports />
  },
  {
    title: "PRODUCTS",
    children: [
      { title: 'Shop Products', path: '/products/shop' },
      { title: 'Group Products', path: '/products/group' },
      { title: 'Vip Offer Products', path: '/products/vip' },
      { title: 'Payback', path: '/products/payback' }
    ],
    icon: <ShoppingCartRounded />
  },
  {
    title: 'SEARCH TOOL',
    children: [
      {
        title: 'Accounts', children: [
          { title: 'Find Player', path: '/searchtool/accounts/findplayer' },
          { title: 'Account Info.', path: '/searchtool/accounts/accountinfo' },
          { title: 'Account Delete History', path: '/searchtool/accounts/accountdeletehistory' },
        ]
      },
      {
        title: 'Withdrawals', children: [
          { title: 'Withdrawal Requests', path: '/searchtool/withdrawals/requests' },
          { title: 'User History', path: '/searchtool/withdrawals/userhistory' },
          { title: 'Purchase History', path: '/searchtool/withdrawals/purchasehistory' }
        ]
      },
      {
        title: 'Currency', children: [
          { title: 'Transactions', path: '/searchtool/currency/transactions' },
          { title: 'Transactinons: Real Cash', path: '/searchtool/currency/rctrx' },
          { title: 'Wallet', path: '/searchtool/currency/wallet' },
        ]
      },
      { title: 'Customer Support', path: '/searchtool/cs' },
      { title: 'Game History', path: '/searchtool/gamehistory' },
      { title: 'Promo / Invite Code History', path: '/searchtool/promoinvitecode' },
      { title: 'Prize Ranking Results', path: '/searchtool/ddtourdata' }
    ],
    icon: <SearchRounded />
  },
  {
    title: 'QA',
    children: [
      { title: 'Delete Accounts', path: '/qa/deleteaccounts' },
      { title: 'Dec Vip Push Test', path: '/qa/decvippushtest' },
      { title: 'Custom Push Test', path: '/qa/custompushtest' }
    ],
    icon: <BugReport />
  },
  {
    title: 'ETC',
    children: [
      { title: 'Admin Roles', path: '/etc/adminroles', forbidden: ['GUEST', 'VIEWER', 'TESTER'] },
      { title: 'Admin Action History', path: '/etc/adminlogs', forbidden: ['GUEST', 'VIEWER'] },
      { title: 'Tester Accounts', path: '/etc/testeraccount', forbidden: ['GUEST', 'VIEWER'] }
    ],
    icon: <SupervisorAccountRounded />,
    forbidden: ['GUEST', 'VIEWER']
  }
]

interface ISideMenuProps {
  open: boolean;
  callback: (open: boolean) => void;
}

const SideMenu = ({ open, callback }: ISideMenuProps) => {

  const history = useHistory()
  const { user } = useUserState()
  const role = user.role

  const drawer = (
    <div>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '212px',
        padding: '4px',
        marginBottom: '10px'
      }}>
        <Clock />

        <IconButton style={{ padding: '11px' }} onClick={() => callback(false)} size="large">
          <Close />
        </IconButton>
      </div>

      <List component='nav'>
        {menus.map((item: any, i: number) =>
          <MenuItem {...item} history={history} role={role} key={i} />
        )}
      </List>

    </div>
  )

  return (
    <Box
      component='nav'
      sx={{ width: { sm: '220px', flexShrink: { sm: 0 } } }} >

      <Drawer
        variant="temporary"
        open={open}
        onClose={() => callback(false)}
        ModalProps={{ keepMounted: true }}
        sx={{
          display: { xs: 'block', sm: 'none' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '220px' },
          '& ::-webkit-scrollbar': { width: 0, height: 0, backgroundColor: 'transparent' }
        }} >
        {drawer}
      </Drawer>

      <Drawer
        variant='persistent'
        anchor='left'
        open={open}
        className='sidemenu'
        sx={{
          display: { xs: 'none', sm: 'block' },
          height: '100%', transition: 'width 225ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '220px' },
        }} >
        {drawer}
      </Drawer>

    </Box>
  );
}


interface IMenuItemProps {
  history: any,
  role: IUserRoles,
  title: string,
  icon?: any,
  path?: string,
  children?: any[],
  forbidden?: IUserRoles[],
  depth?: number
}

const MenuItem = (props: IMenuItemProps) => {

  const convertKeyToUrl = (key: string) => {
    return (key || '').toLowerCase().replace(/\s/g, '');
  }

  const theme = useTheme()
  const { title, history, role, children = [], forbidden = [], depth = 0, path = undefined, icon = undefined } = props
  const isExpandable = children && children.length > 0
  const highlight = !path ?
    window.location.pathname.split('/')[depth + 2] == (convertKeyToUrl(title))
    : path == window.location.pathname
  const [open, setOpen] = useState(highlight)

  useEffect(() => {
    !window.location.pathname.includes('dashboard') && setOpen(highlight)
  }, [props])

  return (
    <Fragment>
      <ListItemButton
        onClick={() => path ? history.push(path == '/home' ? path : `/${config.game}${path}`) : setOpen(!open)}
        selected={path ? window.location.pathname.includes(path) : false}
        dense={!!path}
        component={path !== undefined ? 'a' : 'li'}
        style={{
          backgroundColor: `rgba(0,0,0,${0.02 * depth})`,
          display: forbidden.includes(role) ? 'none' : 'flex',
          padding: depth == 0 ? '4.5px 12px' : !path ? '6px 15px' : '2px 15px',
          color: path && window.location.pathname.includes(path) ? theme.palette.primary.dark : 'inherit'
        }} >

        {icon &&
          <ListItemIcon style={{ minWidth: '30px', color: highlight ? theme.palette.primary.dark : 'inherit' }}>{icon}</ListItemIcon>
        }

        <ListItemText
          primary={path ? title : title.toUpperCase()}
          primaryTypographyProps={{ variant: depth == 0 ? 'overline' : !path ? 'subtitle2' : 'caption' }}
          style={{
            color: (!path && highlight) ? theme.palette.primary.dark : 'inherit',
            marginLeft: `${11 * depth}px`
          }} />

        {isExpandable && (open ? <ExpandLess /> : <ExpandMore />)}

      </ListItemButton>


      {isExpandable &&
        <Collapse in={open} timeout='auto' unmountOnExit >
          <List
            component='div'
            disablePadding
            style={{
              borderTop: '1px solid rgba(100,100,100,0.1)',
              borderBottom: '1px solid rgba(100,100,100,0.1)'
            }} >

            {children.filter(Boolean).map((item, i) =>
              <MenuItem {...item} depth={depth + 1} key={i} history={history} role={role} />
            )}

          </List>
        </Collapse>
      }
    </Fragment>
  )
}

export default SideMenu
